export enum CarpentryProductListSortField {
  SupplierName = 'supplierName',
  Name = 'name',
}

export enum CarpentryProductListSortDirection {
  None = 'none',
  Asc = 'asc',
  Desc = 'desc',
}

export type CarpentryProductListSortDirections = Record<
  CarpentryProductListSortField,
  CarpentryProductListSortDirection
>;

export function getDefaultCarpentryProductListSortDirections(): CarpentryProductListSortDirections {
  return {
    [CarpentryProductListSortField.SupplierName]: CarpentryProductListSortDirection.None,
    [CarpentryProductListSortField.Name]: CarpentryProductListSortDirection.None,
  };
}
